/* eslint-disable @nx/enforce-module-boundaries */
import {
  AuthenticationProviders,
  AuthenticationProvidersContextProvider,
  IAuthProviderResponse,
  type TProvidersProps,
} from '@axo/shared/auth/providers';
import { useTranslation } from '@axo/shared/i18n';
import { MarketCountryCode } from '@axo/shared/types';
import { Card } from '@axo/ui-core/components/Card';
import { Message } from '@axo/ui-core/components/Message';
import { Text } from '@axo/ui-core/components/typography';
import { useAuthenticationContext } from '../../../../../../context/Authentication/AuthenticationContext';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';

const providers: TProvidersProps = {
  Criipto: {
    label: 'Authenticate',
    country: MarketCountryCode.Denmark,
  },
};

export const MitIDActions = () => {
  const { t } = useTranslation();

  const { baseUrl } = useAxoFormContext();
  const { setAuthentication } = useAuthenticationContext();

  const onProviderLoginError = (response: IAuthProviderResponse) => {
    console.error(
      `Error: Provider: ${response.provider} - ${response.errorMessage}`
    );
  };

  const onProviderLoginSuccess = (response: IAuthProviderResponse) => {
    if (response.token) setAuthentication(response.token, response.provider);
  };

  return (
    <>
      <Message variant="info" hasIcon>
        {t('MitID.data')}
      </Message>

      <Card>
        <Text size="s">{t('MitID.disclaimer')}</Text>
        <AuthenticationProvidersContextProvider
          onProviderLoginError={onProviderLoginError}
          onProviderLoginSuccess={onProviderLoginSuccess}
        >
          <AuthenticationProviders providers={providers} axoApiUrl={baseUrl} />
        </AuthenticationProvidersContextProvider>
      </Card>
    </>
  );
};
